import {
  createHighlighter,
  Highlighter,
  HighlighterGeneric,
  ThemedToken,
  LanguageRegistration,
} from "shiki";
import tmLanguageSyntax from "@/src/polar.tmLanguage.json";

type PolarTheme = "min-light" | "min-dark";

const polarSyntaxHighlighterPromise: Promise<
  HighlighterGeneric<"polar", PolarTheme>
> = createHighlighter({
  // This `as` is necessary because of a quirk in Shiki's types: `IRawRepository`
  // has `$self` and `$base` as required properties, but these properties are
  // internally set by @shikijs/core's `textmate.mjs` file.
  langs: [tmLanguageSyntax as unknown as LanguageRegistration],
  themes: ["min-light", "min-dark"],
}).then(
  (highlighter: Highlighter) =>
    highlighter as unknown as HighlighterGeneric<"polar", PolarTheme>
);

export default async function polarSyntaxHighlighting(
  code: string,
  dark = false
): Promise<ThemedToken[][]> {
  const highlighter = await polarSyntaxHighlighterPromise;
  const { tokens } = highlighter.codeToTokens(code, {
    lang: "polar",
    theme: dark ? "min-dark" : "min-light",
  });
  return tokens;
}
